var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',{domProps:{"textContent":_vm._s(_vm.$t('servers.CPU'))}}),_c('v-card-text',[_c('apexchart',{attrs:{"options":_vm.options,"series":_vm.series,"height":"300"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }